import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useEffect } from "react";
import clsx from "clsx";
import remove from "../../../Icons/Event/remove.png";
import styles from "../Events.module.css";
import DeleteIcon from "@material-ui/icons/Delete";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import sjson from "../data.json";
import Tree from "../ReusableComp/Tree";
import SearchIcon from "@material-ui/icons/Search";
import { IconButton, TextField } from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import Input from "../ReusableComp/Input";
import CustomServiceMapping from "./CustomServiceMapping";
import axios from "../../../axios";
import MappingFile from "../../../ReusableComponents/Mapping/MappingFile";
import { useSelector } from "../../../Redux";
import {
  fetchProcessModularData,
  fetchProcessTaskTemplate,
  fetchProcessGlobalTemplate,
} from "./../../../components/IFormDesignerLayout/RequestLogic";
import CustomizedAlert from "../../../ReusableComponents/Alert/CustomizedAlert";
import MultiSelectTreeView from "./SelectVariableMap";
import { useTranslation } from "react-i18next";
import cloneDeep from "lodash-es/cloneDeep";
import { GetStateFromData } from "../../../components/CustomHooks/CustomHooks";
import downarrow_svg from "../../../Icons/Event/downarrow_svg.svg";
import uparrow_svg from "../../../Icons/Event/uparrow_svg.svg";
import { getFormId } from "../../../components/IFormDesignerLayout/IFormDesignerLogic";
import secureLocalStorage from "react-secure-storage";
import secureSessionStorage from "../../../utils/secureSessionStorage";

const useStyles = makeStyles({
  root: {
    padding: 0,
  },
  table: {
    minWidth: 777,
  },
  list: {
    width: 350,
    overflow: "hidden",
  },
  fullList: {
    width: "auto",
  },
});

const CustomService = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [number, setNumber] = useState(0);

  const [filter, setFilter] = useState();

  const [state, setState] = useState(
    props.defaultState || [
      { OutputXMLName: "", OutputParams: {}, InputParams: [], Name: "" },
    ]
  );
  const launchpadKey=secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;
  var jwtToken = launchpadKey || undefined;
  const [anchor, setAnchor] = useState({});
  const [indexUpload, setIndexUpload] = useState(null);

  const [stateMapping, setStateMapping] = useState(false);

  const [saveInJson, setSaveInJson] = useState(true);

  const [jsonAfterUploadingXML, setJsonAfterUploadingXML] = useState({});
  const contexts = GetStateFromData();
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const {
    microFrontendData,
    dataObjectsContent,
    setDataObjectsContent,
    setfilteredDataObject,
    appId,
    activePage,
    filteredDataObject,
    setfilteredDataObjectCopy,
  } = contexts.contexts;
  const [portalState, setPortalState] = useState(
    microFrontendData?.formPageType || microFrontendData?.processName
      ? "Processes"
      : "Portals"
  );
  const [alertData, setAlertData] = React.useState({
    open: false,
    showConfirm: "showNotification",
  });

  console.log(props, "wooo========>>o", state);

  useEffect(() => {
    if (microFrontendData?.componentType === "TF") {
      if (dataObjectsContent && Object.keys(dataObjectsContent).length === 0) {
        var jsonForProcess = {
          taskId: microFrontendData?.taskId,
          processdefId: microFrontendData?.processDefId,
          processState: microFrontendData?.statusType || "L",
        };
        fetchProcessTaskTemplate(jsonForProcess)
          .then((response) => {
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
            setfilteredDataObjectCopy(response.data["children"]);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      }
    } else if (microFrontendData?.componentType === "GT") {
      if (dataObjectsContent && Object.keys(dataObjectsContent).length === 0) {
        var jsonForProcess = {
          globalTemplateId: microFrontendData?.templateId,
        };
        fetchProcessGlobalTemplate(jsonForProcess)
          .then((response) => {
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
            setfilteredDataObjectCopy(response.data["children"]);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      }
    } else if (portalState === "Portals") {
      if (dataObjectsContent && Object.keys(dataObjectsContent).length === 0) {
        fetch("/mdm-rest/app/dataobjects", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "Authorization": jwtToken,
          },
          body: JSON.stringify({
            parent_id: appId,
            type: "AP",
            sort_order: "A",
            order_by: "1",
            records_to_fetch: "30",
            mode: "tree",
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (content) {
            if (content?.status?.subject === "No Data Objects found.") {
              setDataObjectsContent([]);
              setfilteredDataObject([]);
              setfilteredDataObjectCopy([]);
            } else {
              if (content.data.data_objects !== undefined) {
                var jsonDataSend = {
                  data: content.data.data_objects,
                };
                var data = JSON.stringify(content.data.data_objects);
                let formId = getFormId()
                const jsonData = {
                  formId: activePage?.formId || formId.toString(),
                  data: `${data}`,
                };
                axios
                  .post("/idesign/getDataObjectsforMapping", jsonData, {
                    withCredentials: true,
                  })
                  .then((response) => {
                    setDataObjectsContent(response.data["children"]);
                    setfilteredDataObject(response.data["children"]);
                    setfilteredDataObjectCopy(response.data["children"]);
                  })
                  .catch(function (error) {
                    if (error.response) {
                    }
                    console.log("error is", error);
                  });
              }
            }
          })
          .catch((err) => {
            console.log("error is", err);
          });
      }
    } else if (portalState === "Processes") {
      if (dataObjectsContent && Object.keys(dataObjectsContent).length === 0) {
        var jsonForProcess = {
          formId: microFrontendData?.formDefId,
          processdefId: microFrontendData?.processId,
          processState: microFrontendData?.statusType,
          processName: microFrontendData?.processName,
        };
        fetchProcessModularData(jsonForProcess)
          .then((response) => {
            setDataObjectsContent(response.data["children"]);
            setfilteredDataObject(response.data["children"]);
            setfilteredDataObjectCopy(response.data["children"]);
          })
          .catch(function (error) {
            console.log("Error :: ", error);
          });
      }
    }
  }, [portalState]);

  function showAlertConfirmNotifications(dataTobeSet) {
    setAlertData(dataTobeSet);
  }

  const handleInput = (val, index) => {
    let temp = state;
    if (temp[index]) {
      temp[index]["Name"] = val;
    }
    setState(temp);
  };

  const handleDisplayFileDetails = (event, index) => {
    let temp = state;
    temp[indexUpload]["OutputXMLName"] = event.target.files[0].name;

    const file = event.target.files[0];
    var formData = new FormData();
    formData.append("file", file);

    axios
      .post(`idesign/convertCWSXmlToJSON`, formData, {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        setJsonAfterUploadingXML(res.data);
        temp[indexUpload]["OutputParams"] = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
    setState(temp);
    setIndexUpload(null);
    event.target.files = null;
  };

  const handleUploadDelete = (e, index) => {
    e.preventDefault();
    let temp = state;
    temp[index] = { OutputXMLName: "" };
    setState(temp);
    setJsonAfterUploadingXML({});
  };

  const toggleDrawer = (anchor, open, index) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    if (open) {
      setIndexUpload(index);
    } else {
      setIndexUpload(null);
    }
    setAnchor({ [anchor]: open });
    setFilter();
  };

  const AddRow = () => {
    let ans = {
      OutputXMLName: "",
      InputParams: {},
      OutputParams: {},
      Name: "",
    };
    setState([...state, ans]);
  };

  const DeleteRow = (i) => {
    var t = [...state];
    var index = i;
    if (index !== -1) {
      t.splice(index, 1);
      setState(t);
    }
  };

  useEffect(() => {
    if (props.updateHandler) {
      props.updateHandler("CustomWebService", state);
    }
  }, [state]);

  const list = (anchor, inputParams) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      style={{ direction: translationStyles1 ? "rtl" : "ltr" }}
    >
      <List style={{ paddingTop: "0px", height: "90%" }}>
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "46px",
            alignItems: "center",
            marginLeft: translationStyles1 ? null : "13px",
            marginRight: translationStyles1 ? "13px" : null,
            font: " normal normal 600 14px/17px Open Sans",
          }}
        >
          {t("Select Variable(s)")}
        </div>
        <div
          style={{
            background: "#F5F5F5 0% 0% no-repeat padding-box",
            border: "1px solid #F0F0F0",
            height: "32px",
            display: "flex",
            alignItems: "center",
            font: "normal normal 600 12px/16px Open Sans",
            paddingLeft: translationStyles1 ? null : "13px",
            paddingRight: translationStyles1 ? "13px" : null,
          }}
        >
          {t("Select the Variables you want to map")}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "318px",
            maxHeight: "28px",
            border: "1px solid #c4c4c4",
            margin: "8px 12px",
            paddingLeft: "8px",
          }}
        >
          <input
            aria-label={"Search Value"}
            style={{
              font: "normal normal 600 12px/17px Open Sans",
              width: "90%",
              border: "none",
              marginLeft: "-7px",
            }}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
          <IconButton>
            <SearchIcon style={{ marginBottom: "13px" }} />
          </IconButton>
        </div>
        <div style={{ maxHeight: "80%", overflowY: "auto" }}>
          <MultiSelectTreeView
            state={state}
            setState={setState}
            indexUpload={indexUpload}
            defaultState={props?.defaultState}
            searchValue={filter}
            defaultInputParam={inputParams}
          />
        </div>
      </List>
      <footer
        style={{
          width: "100%",
          height: "50px",
          color: "gray",
          position: "fixed",
          bottom: 0,
          boxShadow: "0px 1px 10px grey",
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            paddingTop: "11px",
            position: "inherit",
            right: translationStyles1 ? null : "15px",
            left: translationStyles1 ? "15px" : null,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={`formBuilder-MuiButton-outlined`}
            variant="outlined"
            style={{ width: "54px", height: "28px", fontSize: "12px" }}
            onClick={toggleDrawer("right", false)}
          >
            {t("Cancel")}
          </Button>
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={`formBuilder-MuiButton-outlined`}
            variant="contained"
            style={{
              backgroundColor: "#0072c6",
              color: "white",
              width: "47px",
              height: "28px",
              fontSize: "12px",
              marginLeft: "12px",
            }}
            onClick={toggleDrawer("right", false)}
          >
            {t("Done")}
          </Button>
        </div>
      </footer>
    </div>
  );

  function openMappingCustom(index) {
    setStateMapping(true);
    console.log("state is Index ", index);
    let temp = state;
    if (temp[index]["OutputXMLName"]) {
      setStateMapping(index);
    } else {
      showAlertConfirmNotifications({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: "Please Upload The XML",
      });
    }
  }

  const handleUpload = (index) => {
    setIndexUpload(index);
  };
  return (
    <div className={styles.tableclass}>
      <div className={styles.eventheader}>
        <span>{t("Custom Service")}</span>
        <span>
          <span
            className={styles.addrowbtn}
            style={
              translationStyles1
                ? { marginLeft: "20px", marginRight: "unset" }
                : null
            }
            onClick={() => {
              AddRow();
            }}
          >
            {t("+ Add Custom Service")}
          </span>
          <DeleteIcon
            onClick={() => {
              props.handleDelete(props.name);
            }}
          ></DeleteIcon>
          {
            props?.openedAccordian === props?.name
            ?
            <img
              src={downarrow_svg}
              onClick={()=>props.setopenedAccordian("") }
              style={{
                width:"24px", 
                height :"24px",
                margin:"0px 0 0 8px" 
              }}
            />
            :
            <img
              onClick={()=>props.setopenedAccordian(props?.name) }
              src={uparrow_svg}
              style={{
                width:"24px", 
                height :"24px",
                margin:"0px 0 0 8px" 
              }}
            />
          }
        </span>
      </div>
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow style={{ height: "40px" }}>
              <TableCell
                className={styles.tableelementhead}
                style={{
                  width: "53px",
                  padding: "0px",
                  textAlign: "center",
                }}
                align="center"
              >
                {t("S No.")}
              </TableCell>
              <TableCell
                className={styles.tableelementhead}
                style={{ width: "175px", textAlign: "center" }}
                align="center"
              >
                {t("Service Name")}
              </TableCell>
              <TableCell
                className={styles.tableelementhead}
                style={{ widht: "196px", textAlign: "center" }}
                align="center"
              >
                {t("Input")}
              </TableCell>
              <TableCell
                className={styles.tableelementhead}
                style={{ width: "199px", textAlign: "center" }}
                align="center"
              >
                {t("Output XML")}
              </TableCell>
              <TableCell
                className={styles.tableelementhead}
                style={{ width: "116px", textAlign: "center" }}
                align="center"
              >
                {t("Output")}
              </TableCell>
              <TableCell
                style={{ width: "41px", textAlign: "center" }}
                align="center"
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {state &&
              state.length > 0 &&
              state.map((row, index) => {
                return (
                  <TableRow
                    key={`${"customServiceItem"}_${index}`}
                    style={{ height: "53px" }}
                  >
                    <TableCell className={styles.tableelement} align="center">
                      {index + 1}
                    </TableCell>
                    <TableCell className={styles.tableelement} align="center">
                      <Input
                        aria-label={"Custom Service"}
                        customService
                        width={154}
                        handleInput={(val) => handleInput(val, index)}
                        state={state[index] && state[index].Name}
                      >
                        {state[index] && state[index].Name}
                      </Input>
                    </TableCell>
                    <TableCell className={styles.tableelement} align="center">
                      <span>
                        {number === 0 ? (
                          <span
                            className={styles.defaultbtn}
                            onClick={toggleDrawer("right", true, index)}
                          >
                            {t("Select Variables")}
                          </span>
                        ) : (
                          <span
                            style={{
                              font: "normal normal 12px/13px Open Sans",
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-around",
                              alignItems: "center",
                            }}
                          >
                            <span>
                              <span
                                style={{
                                  textDecoration: "underline",
                                  color: "#2F5BBF",
                                  margin: "5px",
                                }}
                                onClick={toggleDrawer("right", true, index)}
                              >
                                Edit Variables
                              </span>
                            </span>
                          </span>
                        )}
                      </span>
                      <Drawer
                        className="formBuilder_main_app"
                        anchor={translationStyles1 ? "left" : "right"}
                        open={anchor["right"]}
                        onClose={toggleDrawer("right", false)}
                      >
                        {list("right", state[index].InputParams)}
                      </Drawer>
                    </TableCell>
                    <TableCell className={styles.tableelement} align="center">
                      <input
                        aria-label={"Upload Image"}
                        k={index}
                        style={{ border: "1px solid black", display: "none" }}
                        onChange={(event) =>
                          handleDisplayFileDetails(event, index)
                        }
                        id="upload-image"
                        type="file"
                      />

                      {state[index] && state[index].OutputXMLName ? (
                        <span className={styles.uploadedFileName}>
                          <span>{state[index]["OutputXMLName"]}</span>

                          <span
                            className={styles.defaultbtn}
                            onClick={(e) => handleUploadDelete(e, index)}
                            style={{ padding: "5px" }}
                          >
                            <img src={remove} alt="remove" />
                          </span>
                        </span>
                      ) : (
                        <label htmlFor="upload-image">
                          <span
                            onClick={() => handleUpload(index)}
                            className={styles.uploadbtn}
                          >
                            {t("Upload XML")}
                          </span>
                        </label>
                      )}
                    </TableCell>
                    <TableCell className={styles.tableelement} align="center">
                      <span
                        onClick={() => openMappingCustom(index)}
                        className={styles.defaultbtn}
                      >
                        {t("Map Parameters")}
                      </span>
                    </TableCell>
                    {stateMapping === index ? (
                      <CustomServiceMapping
                        stateOpen={true}
                        index={index}
                        currentState={Object.assign({}, state[index])}
                        setStateMapping={setStateMapping}
                        jsonAfterUploadingXML={
                          Object.keys(jsonAfterUploadingXML).length !== 0 &&
                          jsonAfterUploadingXML
                        }
                        setState={setState}
                        state={state}
                        //
                        stateJsonBeforeSaving={cloneDeep(
                          state[index]["OutputParams"]
                        )}
                        defaultState={props.defaultState}
                        saveInJson={saveInJson}
                        setSaveInJson={setSaveInJson}
                      />
                    ) : null}
                    <TableCell className={styles.lastelement} align="center">
                      <span
                        className={styles.defaultbtn}
                        onClick={() => {
                          DeleteRow(index);
                        }}
                      >
                        <img src={remove} alt="remove" />
                      </span>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      {alertData.open === true && <CustomizedAlert alertData={alertData} />}
    </div>
    // </div>
  );
};

export default CustomService;
